import { getConnectedBrokerPaymentSpeedLabel } from "helpers/paymentSpeedLabel";
import { IInvitedGroup } from "models/User";
import styles from "./style.module.scss";

interface IProps {
  type: "pending" | "connected";
  data: IInvitedGroup;
}

export default function InvitedGroupItem({ type, data }: Readonly<IProps>) {
  // HP-8422: read the speed agreed for this relationship. This used to show whichever option the
  // broker had flagged is_default, so every connection read as the broker's fastest term.
  const paymentSpeedLabel = getConnectedBrokerPaymentSpeedLabel(
    data.payout_days,
    data.payment_speed_options
  );

  return (
    <ul className={styles.invitedGroupItemContainer}>
      <li>
        <span className="font-bold">Broker</span>
        <span className={styles.data}>{data.group_data.group_name}</span>
      </li>
      <li>
        <span className="font-bold">Email</span>
        <span className={styles.data}>{data.group_data.company_email}</span>
      </li>
      <li>
        <span className="font-bold">Phone</span>
        <span className={styles.data}>{data.group_data.company_phone_number}</span>
      </li>
      <li>
        <span className="font-bold">MC #</span>
        <span className={styles.data}>{data.group_data.company_mc}</span>
      </li>
      <li>
        <span className="font-bold">DOT #</span>
        <span className={styles.data}>{data.group_data.company_dot}</span>
      </li>
      {type === "connected" ? (
        <li>
          <span className="font-bold">Payment Speed</span>
          <span className={styles.data}>{paymentSpeedLabel ?? "—"}</span>
        </li>
      ) : null}
    </ul>
  );
}
